module.exports = __webpack_public_path__ + "static/media/aboutGlass.3c8c0d26.svg";